import React from "react";

export const PoliticalPartyReports = () => {
    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Political Party Reports</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
            </div>
        </div>
    );
};
